import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { EobProcessingFinishedEventProps } from '../../model'

/** Title-only event rendered when EOB processing is fully complete */
export function EobProcessingFinishedEvent({
  event,
  searchQuery,
}: {
  event: EobProcessingFinishedEventProps
  searchQuery: string
}) {
  return (
    <div className="flex flex-col gap-0.5 py-[3px]">
      <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
    </div>
  )
}
